const mutations = {
  SET_MAIN_FEATURES(state, payload) {
    state.mainFeatures = payload;
  },
  SET_MAIN_FEATURE(state, payload) {
    state.mainFeature = payload;
  },
};

export default mutations;
